import React from 'react';
import { connect } from 'react-redux';

import LoginButton from './LoginButton';

import { updateQueryString } from '../../redux/router/actions';

const LoginButtonConnected = (props) => <LoginButton {...props} />;

const mapActionsToProps = {
  updateQueryString,
};

export default connect(null, mapActionsToProps)(LoginButtonConnected);
